import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboards/project'
    {path: '', pathMatch : 'full', redirectTo: '404-not-found'},

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'funcionariogeneral'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
             // pantalla principal 
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
             // kiosko autosvicio
            {path: 'kioskoautoservicio', loadChildren: () => import('app/modules/landing/kioskoautoservicio/kioskoautoservicio.routes')},
             // kiosko apoyo funcionario
            {path: 'kiosko', loadChildren: () => import('app/modules/landing/kiosko/kiosko.routes')},
        ]
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [


            // Funcionario1. Trámites en sala
            {path: 'funcionariogeneral', loadChildren: () => import('app/modules/admin/funcionariogeneral/funcionariogeneral.routes')}, 

            // Funcionario2. Turno en atención
            {path: 'funcionarioturnoenatencion', loadChildren: () => import('app/modules/admin/funcionarioturnoenatencion/funcionarioturnoenatencion.routes')},

             // Funcionario3. Monitoreo del modulo
            {path: 'funcionariomonitoreo', loadChildren: () => import('app/modules/admin/funcionariomonitoreo/funcionariomonitoreo.routes')},

            // Admin1. Dashboard Admin
            {path: 'dashadmin', loadChildren: () => import('app/modules/admin/dashadmin/dashadmin.routes')},

            // Admin. Catalogos form de registro
            {path: 'formdependencia', loadChildren: () => import('app/modules/admin/formdependencia/formdependencia.routes')},
            {path: 'formtramite', loadChildren: () => import('app/modules/admin/formtramite/formtramite.routes')},
            {path: 'formusuario', loadChildren: () => import('app/modules/admin/formusuario/formusuario.routes')},
            {path: 'formmodulo', loadChildren: () => import('app/modules/admin/formmodulo/formmodulo.routes')},
            {path: 'formkiosko', loadChildren: () => import('app/modules/admin/formkiosko/formkiosko.routes')},
            {path: 'formsala', loadChildren: () => import('app/modules/admin/formsala/formsala.routes')},
            {path: 'formsucursales', loadChildren: () => import('app/modules/admin/formsucursales/formsucursales.routes')},
            {path: 'formtramitesderivable', loadChildren: () => import('app/modules/admin/formtramitesderivable/formtramitesderivable.routes')},
            {path: 'formusuario', loadChildren: () => import('app/modules/admin/formusuario/formusuario.routes')},
            {path: 'formperfil', loadChildren: () => import('app/modules/admin/formperfil/formperfil.routes')},
            {path: 'formgrupo', loadChildren: () => import('app/modules/admin/formgrupo/formgrupo.routes')},
            {path: 'formmultimedia', loadChildren: () => import('app/modules/admin/formmultimedia/formmultimedia.routes')},

            // Admin. Catalogos concentrado
            {path: 'tabladependencia', loadChildren: () => import('app/modules/admin/tabladependencia/tabladependencia.routes')},
            {path: 'tablamodulo', loadChildren: () => import('app/modules/admin/tablamodulo/tablamodulo.routes')},
            {path: 'tablasala', loadChildren: () => import('app/modules/admin/tablasala/tablasala.routes')},
            {path: 'tablatramites', loadChildren: () => import('app/modules/admin/tablatramites/tablatramites.routes')},
            {path: 'tablausuario', loadChildren: () => import('app/modules/admin/tablausuario/tablausuario.routes')},
            {path: 'tablaperfil', loadChildren: () => import('app/modules/admin/tablaperfil/tablaperfil.routes')},
            {path: 'tablagrupo', loadChildren: () => import('app/modules/admin/tablagrupo/tablagrupo.routes')},
            {path: 'tablamultimedia', loadChildren: () => import('app/modules/admin/tablamultimedia/tablamultimedia.routes')},
            {path: 'tablakiosko', loadChildren: () => import('app/modules/admin/tablakiosko/example.routes')},
            {path: 'tablasucursal', loadChildren: () => import('app/modules/admin/tablasucursal/example.routes')},

            {path: 'reporte-turnos', loadChildren: () => import('app/modules/admin/reporte-turnos/reporte-turnos.routes')},

            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            // 404 & Catch all
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes')},
            {path: '**', redirectTo: '404-not-found'},

        ]
    }
];
